<script setup>
  import { onMounted, ref, computed } from 'vue';
  import CartList from '../components/cart/CartList.vue';
  import CartHeader from '../components/cart/CartHeader.vue';
  import CartGridHeader from '../components/cart/CartGridHeader.vue';
  import CartFooter from '../components/cart/CartFooter.vue';
  import CartFooterV2 from '../components/cart/CartFooterV2.vue';
  import CartPriceDetail from '../components/cart/CartPriceDetail.vue';
  import CartPriceDetailV2 from '../components/cart/CartPriceDetailV2.vue';
  import CartDetail from '../components/cart/CartDetail.vue';
  import CartSummary from '../components/cart/CartSummary.vue';
  import CartComments from '../components/cart/CartComments.vue';
  import { useBrowseCartStore } from '../stores/BrowseCartStore.js';
  import { useRoute } from 'vue-router';
  import NotFound from '../pages/NotFound.vue';
  import CartRefund from '../components/cart/CartRefund.vue';
  import CartRefundCopies from '../components/cart/CartRefundCopies.vue';
  import Notice from '../components/ui/Notice.vue';
  import { useOfferStore } from '../stores/OfferStore';
  import { useI18n } from 'vue-i18n';
  import { useCartRefundStore } from '../stores/CartRefundStore.js';

  const route = useRoute();
  const cartId = route.params.id;

  const cartStore = useBrowseCartStore();
  const offerStore = useOfferStore();
  const cartRefundStore = useCartRefundStore();
  const { t } = useI18n();
  cartStore.cart = null;

  onMounted( async () => {
    await cartStore.fetchCart(cartId);
    const title_name = cartStore.cart.name ? cartStore.cart.name : t('not_found.title');
    document.title = `${title_name} | ${document.title}`;
  });

  const showRefund = ref(false);

  const toogleRefund = () => {
    showRefund.value = !showRefund.value;
    cartStore.refund_mode = showRefund.value;
  }

  const deleteReplacedOffers = async () => {
    if (!cartStore.cart.automatic_offer_replacement_and_removal) return;
    const replaced_offers = offerStore.offers.filter(offer => !offer.original_offer);
    if (replaced_offers.length > 0) {
        const offerIds = replaced_offers.map(offer => offer.offer.id);
        const params = { id: cartId, offerIds: offerIds };

        await offerStore.deleteCheckedOffersByCartId(params);
    }
  };

</script>

<template>
  <template v-if="cartStore.cart !== 'not_found'">
    <Notice v-if="cartRefundStore.refund_confirmation" type="success">
        {{ t('cart.refund.refund_cofirmed') }}
    </Notice>
    <CartHeader @toogleRefundBox="toogleRefund" />
    <div v-if="cartStore.cart">
      <CartDetail :key="cartStore.cart.id" :cart="cartStore.cart" :cartOfferQuantity="offerStore.cartOffersQuantity" />
      <div class="refund-container">
        <div class="column-box">
           <CartRefund v-if="showRefund" @toogleRefundBox="toogleRefund" />
        </div>
        <div class="column-box">
          <CartRefundCopies :cartId="cartStore.cart.id"/>
        </div>
      </div>
      <div class="row" v-if="cartStore.cart.cart_content_summary || cartStore.cart.policy.cart_comments">
        <div class="col-12" :class="{ 'col-xl-8': cartStore.cart.policy.cart_comments }" v-if="cartStore.cart.cart_content_summary">
          <CartSummary :key="`cart-summary-${cartStore.cart.id}`" />
        </div>
        <div class="col-12" :class="{ 'col-xl-4': cartStore.cart.cart_content_summary }" v-if="cartStore.cart.policy.cart_comments">
          <CartComments :key="`cart-comments-${cartStore.cart.id}`" :cartId="cartStore.cart.id" />
        </div>
      </div>
      <CartGridHeader :key="cartStore.cart.id" />
      <CartList :key="cartStore.cart.id" :cart="cartStore.cart" :display_offer_details="cartStore.cart.policy.display_offer_details" />
      <CartPriceDetail v-if="cartStore.cart.library.calculation_method === 'per_cart'" />
      <CartPriceDetailV2 v-else />
      <CartFooter :key="`cart-footer-${cartStore.cart.id}`" @deleteReplacedOffers="deleteReplacedOffers" v-if="cartStore.cart.library.calculation_method === 'per_cart'" />
      <CartFooterV2 :key="`cart-footer-v2-${cartStore.cart.id}`" @deleteReplacedOffers="deleteReplacedOffers" v-else />
    </div>
  </template>
  <NotFound v-else />
</template>

<style scoped>
  .refund-container {
    display: flex;
    flex-direction: column;

  }
  .refund-container h3 {
    display: block;
    margin: 0 0 20px 0;
    padding: 0;
  }
</style>
